import { MUT_ALTERS } from "./mut-columns.js";

export const tasksTable = `
CREATE TABLE IF NOT EXISTS tasks (
  id              TEXT PRIMARY KEY,
  title           TEXT NOT NULL,
  notes           TEXT NOT NULL DEFAULT '',
  due_at          TEXT,
  deadline_at     TEXT,
  all_day         INTEGER NOT NULL DEFAULT 0,
  duration_minutes INTEGER NOT NULL DEFAULT 0,
  priority        TEXT NOT NULL DEFAULT 'none',
  matrix_pos      TEXT,
  matrix_hidden   INTEGER NOT NULL DEFAULT 0,
  custom_color    TEXT,
  is_event        INTEGER NOT NULL DEFAULT 0,
  location        TEXT NOT NULL DEFAULT '',
  label_ids       TEXT NOT NULL DEFAULT '[]',
  reminder_offsets TEXT NOT NULL DEFAULT '[]',
  tz              TEXT,
  topic_ids       TEXT NOT NULL DEFAULT '[]',
  calendar_id     TEXT,
  external_id     TEXT,
  ical_uid        TEXT,
  etag            TEXT,
  rev             INTEGER NOT NULL DEFAULT 0,
  source          TEXT,
  external_calendar_id TEXT,
  link_rev        INTEGER NOT NULL DEFAULT 0,
  mut             INTEGER NOT NULL DEFAULT 0,
  server_acked_mut INTEGER NOT NULL DEFAULT 0,
  google_acked_mut INTEGER NOT NULL DEFAULT 0,
  status          TEXT NOT NULL DEFAULT 'open',
  completed_at    TEXT,
  snoozed_until   TEXT,
  recurrence_id   TEXT,
  parent_id       TEXT,
  subtask_parent_id TEXT,
  subtask_order   INTEGER NOT NULL DEFAULT 0,
  created_at      TEXT NOT NULL,
  updated_at      TEXT NOT NULL,
  deleted_at      TEXT
);
`.trim();

export const tasksIndexes = [
  "CREATE INDEX IF NOT EXISTS idx_tasks_due_at ON tasks(due_at);",
  "CREATE INDEX IF NOT EXISTS idx_tasks_status ON tasks(status);",
  "CREATE INDEX IF NOT EXISTS idx_tasks_recurrence ON tasks(recurrence_id);",
  "CREATE INDEX IF NOT EXISTS idx_tasks_calendar ON tasks(calendar_id);",
  "CREATE INDEX IF NOT EXISTS idx_tasks_ical_uid ON tasks(ical_uid);",
  "CREATE INDEX IF NOT EXISTS idx_tasks_subtask_parent ON tasks(subtask_parent_id);",
  "CREATE INDEX IF NOT EXISTS idx_tasks_snoozed_until ON tasks(snoozed_until);",
];

/** ALTER statements to bring existing tables up to the current schema.
 *  Each is wrapped in try/catch by migrate() because re-applying ADD COLUMN
 *  on a column that already exists is an error. */
export const tasksAlters = [
  "ALTER TABLE tasks ADD COLUMN deadline_at TEXT;",
  "ALTER TABLE tasks ADD COLUMN is_event INTEGER NOT NULL DEFAULT 0;",
  "ALTER TABLE tasks ADD COLUMN location TEXT NOT NULL DEFAULT '';",
  "ALTER TABLE tasks ADD COLUMN label_ids TEXT NOT NULL DEFAULT '[]';",
  "ALTER TABLE tasks ADD COLUMN reminder_offsets TEXT NOT NULL DEFAULT '[]';",
  "ALTER TABLE tasks ADD COLUMN tz TEXT;",
  "ALTER TABLE tasks ADD COLUMN topic_ids TEXT NOT NULL DEFAULT '[]';",
  "ALTER TABLE tasks ADD COLUMN calendar_id TEXT;",
  "ALTER TABLE tasks ADD COLUMN external_id TEXT;",
  "ALTER TABLE tasks ADD COLUMN ical_uid TEXT;",
  "ALTER TABLE tasks ADD COLUMN etag TEXT;",
  "ALTER TABLE tasks ADD COLUMN rev INTEGER NOT NULL DEFAULT 0;",
  "ALTER TABLE tasks ADD COLUMN source TEXT;",
  "ALTER TABLE tasks ADD COLUMN external_calendar_id TEXT;",
  "ALTER TABLE tasks ADD COLUMN subtask_parent_id TEXT;",
  "ALTER TABLE tasks ADD COLUMN subtask_order INTEGER NOT NULL DEFAULT 0;",
  "ALTER TABLE tasks ADD COLUMN completed_at TEXT;",
  "ALTER TABLE tasks ADD COLUMN snoozed_until TEXT;",
  "ALTER TABLE tasks ADD COLUMN matrix_pos TEXT;",
  "ALTER TABLE tasks ADD COLUMN matrix_hidden INTEGER NOT NULL DEFAULT 0;",
  // Revision of the remote-link block. Existing rows start at 0, which the merge
  // treats as "same generation, grow-only per field" — so an upgrade converges
  // without a resync. See packages/core/src/tasks/remote-link.ts.
  "ALTER TABLE tasks ADD COLUMN link_rev INTEGER NOT NULL DEFAULT 0;",
  // DEVICE-LOCAL change tracking (see core sync/device-local.ts). Backfilled by
  // `backfillMutColumns`; dirty(destination) === mut > acked. The old
  // `uploaded_link_rev` column is superseded (left in place on old installs).
  ...MUT_ALTERS("tasks"),
];
